const styles = (theme) => ({
  root: {
    transition: 'ease width 0.4s',
    width: 390,
    [theme.breakpoints.down('lg')]: {
      width: 290,
    },
    height: '100vh',
    minWidth: 290,
    padding: '30px 24px 0 24px',
    display: 'flex',
    flexDirection: 'column',
    boxSizing: 'border-box',
    overflow: 'auto',
    flexShrink: 0,

    // This can be removed with https://github.com/clearbit/clearkit-one/pull/60
    '& *:focus': {
      outline: 'none',
    },
  },

  legacyFont: {
    color: 'white',
  },

  legacyBackground: {
    background: '#4A5259',
  },

  segmentLoadingArea: {
    flexGrow: 0,
  },

  segments: {
    overflowY: 'auto',
    overflowX: 'hidden',
    flexGrow: 0,
    width: 'calc(100% + 24px)',

    marginLeft: -12,
    padding: '8px 12px',
  },

  mainTitle: {
    margin: '0 10px 18px',
    fontSize: 26,
    fontWeight: '600',
    letterSpacing: 0,
    lineHeight: '30px',
  },

  segmentLink: {},

  selectedSegment: {
    '&:focus': {
      boxShadow: 'inset 0 0 0 1px rgba(255, 255, 255, .1)',
    },
    '& $homeIcon': {
      opacity: 1,
    },
  },

  // Base styles

  segmentSearch: {
    flexShrink: 0,
    marginBottom: 12,

    '& input': {
      width: '100%',
      paddingLeft: '36px !important',
    },
  },

  legacySegmentSearch: {
    '& input': {
      color: '#fff',
      background: 'rgba(0, 0, 0, .05)',
      boxShadow:
        'inset 0 0 0 1px rgba(39, 40, 42, .2), inset 0 2px 1px rgba(39, 40, 42, .05), 0 0 0 3px rgba(213, 118, 240, 0)',

      '&:focus': {
        background: 'rgba(0, 0, 0, .1)',
        boxShadow:
          'inset 0 0 0 1px rgba(193, 126, 241, 1), inset 0 2px 1px rgba(39, 40, 42, .05), 0 0 0 3px rgba(213, 118, 240, .3)',

        '& ~ * > $searchIcon': {
          fill: '#fff',
        },
      },

      '&::placeholder': {
        color: 'rgba(255, 255, 255, 0.4)',
      },

      '&::-webkit-input-placeholder': {
        color: 'rgba(255, 255, 255, 0.4)',
      },
    },
  },

  searchIcon: {
    marginLeft: 8,
    transition: 'fill ease .2s',
  },

  legacySearchIcon: {
    fill: 'rgba(255, 255, 255, .5)',
  },

  homeLink: {
    display: 'flex',
    flex: '0 0 auto',
    alignItems: 'center',
    fontWeight: 500,
    fontSize: 14,
    lineHeight: '29px',
    paddingLeft: 12,
    paddingBottom: 1,
    width: '100%',
    borderRadius: 6,
    transition: 'background-color ease .2s',
  },

  legacyHomeLink: {
    color: 'white',
    '&:focus, &:hover': {
      backgroundColor: 'rgba(255, 255, 255, .1)',

      '& $homeIcon': {
        opacity: 1,
      },
    },
  },

  legacyActionMenuItem: {
    color: 'white',

    '&:hover, &:focus': {
      background: 'rgba(255, 255, 255, .1)',
    },

    '&.selected': {
      background: 'linear-gradient(to left, #637EFF 0%, #C363E5 100%)',
    },
  },

  homeIcon: {
    opacity: 0.5,
    marginLeft: -4,
    marginRight: 8,
    transition: 'opacity ease .2s',
  },

  // Footer

  newButtonWrapper: {
    position: 'sticky',
    marginTop: 'auto',
    paddingTop: 12,
    bottom: 0,
  },

  newButton: {
    width: '100%',
  },
});

export default styles;
